export default function GoogleSignInButton({ onClick, disabled, label = "Sign in with Google" }) {
  return (
    <button type="button" className="google-btn" onClick={onClick} disabled={disabled}>
      <span className="google-btn__icon">G</span>
      {label}
    </button>
  );
}
